<script>

import { claim_component } from "svelte/internal";

</script>
<div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gy-lg gx-lg">
  <slot></slot>
</div>